import React, { useEffect } from 'react';
import cx from 'classnames';
import { Link, Button } from '@resy/ui-kitchen';
import './SideDrawer.scss';
import PropTypes from 'prop-types';
import { updateLinksWithOriginB2B, handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import Times from '../../../../images/amexrga/times.svg';
import CustomImage from '../../CustomImage';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';

const SideDrawer = ({
  menuItems,
  show,
  drawerClickHandler,
  setScrollForDirMenu,
  mobileMenuContent,
  onAfterOpen,
  onAfterClose,
  baseRequestUrl,
  headerTextImg,
  amexFooterImg,
  printContent,
  hasOriginB2B,
  Analytics,
}) => {
  const {
    headerExplore,
    headline,
    amexLogoText,
    gda,
  } = { ...mobileMenuContent };

  const handleClose = () => {
    onAfterClose();
    drawerClickHandler();
  };

  const handleTaggingClick = (link, menuItem) => {
    handleClose();
    const extraParam = {
      action_name: 'Menu - Click',
      item_name: menuItem.text,
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
    if (link.includes('global-dining-access-partner-page')) {
      window.open(updateLinksWithOriginB2B(link, hasOriginB2B), '_blank');
    } else window.open(link, '_self');
  };

  const handleOnKeyPress = (eventVal) => {
    if (eventVal.key === 'Escape') {
      handleClose();
      document.removeEventListener('keyup', handleOnKeyPress);
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener('keyup', handleOnKeyPress);
      onAfterOpen('.GDA__SideDrawer');
    }
  });

  return (
    <div
      className={cx('GDA__SideDrawer', {
        open: show,
      })}
      id="sideDrawer"
      hidden={!show}
    >
      <div className="GDA__SideDrawer__logo-drawer-wrap">
        <Button
          variant="no-style"
          type="button"
          data-test-id="amexGDA_mobile-menu-close"
          className="GDA__SideDrawer__toggle-button"
          onClick={handleClose}
          aria-label="Close mobile navigation"
        >
          <Times />
        </Button>
        <Link
          className="GDA__SideDrawer__logo-drawer accessible-focus"
          href={updateLinksWithOriginB2B('global-dining-access', hasOriginB2B)}
        >
          <CustomImage key={headerTextImg} imageName={headerTextImg} baseRequestUrl={baseRequestUrl} fileType="svg" />
          <span>{printContent(gda, 'gda')}</span>
        </Link>
      </div>
      <ul>
        {menuItems?.map((menuItem, index) => {
          const { link } = menuItem;
          return (

            <li key={menuItem.id}>
              {(!menuItem.id || menuItem.id === '') && printContent(menuItem.id, 'id')}
              {(!menuItem.link || menuItem.link === '') && printContent(menuItem.link, 'link')}
              {(menuItem.internal === undefined || menuItem.internal === null || menuItem.internal === '') && printContent(menuItem.internal, 'internal')}
              {menuItem.internal
                ? (
                  <Button
                    variant="no-style"
                    className="ResyAmexGDAHeader__nav--button"
                    type="button"
                    data-test-id={`amexgda_mobile_menu-navigation-item${index}`}
                    onClick={async () => {
                      handleClose();
                      document.removeEventListener('keyup', handleOnKeyPress);
                      await setScrollForDirMenu(link);
                      const extraParam = {
                        action_name: 'Menu - Click',
                        item_name: menuItem.text,
                      };
                      handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
                    }}
                  >
                    {printContent(menuItem.text, 'text')}
                  </Button>
                )
                : (
                  <Link
                    className="GDA__SideDrawer--link"
                    onClick={() => handleTaggingClick(link, menuItem)}
                  >
                    {printContent(menuItem.text, 'text')}
                  </Link>
                )}
            </li>
          );
        })}
      </ul>
      {menuItems?.length === 0 && printContent(menuItems, 'menuItems')}
      <hr />
      <p>
        <Link className="GDA__SideDrawer--explore" href="/">
          {printContent(headerExplore, 'headerExplore')}
        </Link>
      </p>
      <div className="GDA__SideDrawer__Amex">
        <p className="GDA__SideDrawer__Amex--headline">{printContent(headline, 'headline')}</p>
        <p>
          <CustomImage key={amexFooterImg} imageName={amexFooterImg} baseRequestUrl={baseRequestUrl} fileType="svg" />
          <span>{printContent(amexLogoText, 'amexLogoText')}</span>
        </p>
      </div>
    </div>
  );
};

SideDrawer.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  drawerClickHandler: PropTypes.func.isRequired,
  setScrollForDirMenu: PropTypes.func,
  mobileMenuContent: PropTypes.objectOf(PropTypes.string).isRequired,
  onAfterClose: PropTypes.func.isRequired,
  onAfterOpen: PropTypes.func.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  headerTextImg: PropTypes.string.isRequired,
  amexFooterImg: PropTypes.string.isRequired,
  printContent: PropTypes.func.isRequired,
  hasOriginB2B: PropTypes.bool.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

SideDrawer.defaultProps = {
  setScrollForDirMenu: () => { },
};

export default SideDrawer;
